import React, { createContext, ReactElement, useState } from 'react'

/**
 * Modal action prompt context type.
 */
export type ModalExitPromptType = {
    closeExitPrompt: () => void
    displayExitPrompt: () => void
    isExitPromptDisplayed: boolean
}

/**
 * Modal action prompt provider props type.
 */
type ModalExitPromptProviderProps = {
    children: React.ReactNode
}

/**
 * Provides access to prompt resource. Global state handling flag depicting whether the close prompt should be rendered.
 * This context does not render the prompt itself.
 * @param children Children to render.
 */
export const ModalExitPromptContextProvider = ({ children }: ModalExitPromptProviderProps): ReactElement => {
    const [isExitPromptDisplayed, setIsExitPromptDisplayed] = useState(false)

    const displayExitPrompt = (): void => {
        // Display prompt.
        setIsExitPromptDisplayed(true)
    }

    return (
        <ModalExitPromptContext.Provider
            value={{
                displayExitPrompt,
                isExitPromptDisplayed,
                closeExitPrompt: (): void => {
                    setIsExitPromptDisplayed(false)
                }
            }}
        >
            {children}
        </ModalExitPromptContext.Provider>
    )
}

/**
 * Context for prompt resource.
 */
// eslint-disable-next-line
const ModalExitPromptContext = createContext<ModalExitPromptType>(undefined as any)
export default ModalExitPromptContext
